<script>
import SubHeader from "@/components/SubHeader";
export default {
  components: {
    SubHeader,
  },
  data: () => ({
    headerProps: {
      title: "Gerenciar Clientes",
      btns: [
        {
          text: "Novo",
          color: "primary",
          action: () => {},
          icon: "mdi-plus",
          path: "/cadastros/clientes/new",
          isRedirector: true,
        },
        {
          text: "Recarregar",
          color: "primary",
          action: () => {},
          icon: "mdi-update",
          path: "",
          isRedirector: false,
        },
      ],
    },
    dialog: false,
    search: "",
    headers: [
      { text: "Nome", value: "nome", sortable: false },
      // { text: "Tipo de Documento", value: "tipo_documento", sortable: false },
      { text: "Documento", value: "documento", sortable: false },
      { text: "Ações", value: "action", sortable: false, align: "right" },
    ],
    items: [],
  }),
  created() {
    this.initialize();
    this.headerProps.btns[1].action = () => this.initialize();
  },

  methods: {
    handleSearch: function (value) {
      this.search = value;
    },
    initialize() {
      this.items = [];
      this.$store.dispatch("activeLoader", true);
      this.$http.get("/clientes").then((r) => {
        this.items = r.data;
        this.$store.dispatch("activeLoader", false);
      });
    },
    editar(id) {
      this.$router.push(`/cadastros/clientes/editar/${id}`);
    },
    deleteItem(id) {
      let c = confirm("Deseja apagar o registro?");
      if (c) {
        this.$store.dispatch("activeLoader", true);
        this.$http.post(`/clientes/delete/${id}`).then((r) => {
          this.$store.dispatch("activeLoader", false);
          alert(r.data.success);
          this.initialize();
        });
      }
    },
  },
};
</script>
